import { PropsWithChildren } from "react";
import { Box, BoxProps, Theme } from "@mui/material";

interface IChartLoadingStateProps extends BoxProps {
    numberOfLines?: number;
}

export const ChartLoadingState = ({ children, numberOfLines = 4, ...boxProps }: PropsWithChildren<IChartLoadingStateProps>) => {
    return (
        <Box
            role="status"
            aria-live="polite"
            aria-label="Chart is loading"
            sx={{
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                pl: 5,
                bgcolor: "white",
                ...boxProps.sx,
            }}
            {...boxProps}
        >
            {[...Array.from({ length: numberOfLines })].map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        backgroundImage: (theme: Theme) => `linear-gradient(to right, ${theme.palette.gray[200]} 20%, white 0%)`,
                        backgroundPosition: "bottom",
                        backgroundSize: "10px 2px",
                        backgroundRepeat: "repeat-x",
                        height: "3px",
                    }}
                />
            ))}
            {children}
        </Box>
    );
};
